module.exports = __webpack_public_path__ + "static/media/crm-logo.93e09177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crm-logo.png
// module id = 494
// module chunks = 3